import React from 'react';
import DefaultSimManuelRecipient from '../components/ManulRecipient/DefaultSimManuelRecipient';
import { iban } from '../utils/DictionaryManagementUtils';
//= ========================================================================

const Sim_B07_SendMoneyToIBANManually = ({
  globJSON,
  selectedScreen,
  language,
  simPlatform,
  slideshowRefs = null,
}) => (
  <DefaultSimManuelRecipient
    globJSON={globJSON}
    selectedScreen={selectedScreen}
    language={language}
    simPlatform={simPlatform}
    slideshowRefs={slideshowRefs}
    manualName={iban}
  />
);

export default Sim_B07_SendMoneyToIBANManually;
